var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right"},[_c('Title',{scopedSlots:_vm._u([{key:"name",fn:function(){return [_vm._v(" 中心理念销售情况 ")]},proxy:true}])}),_c('div',{staticClass:"content"},[_c('Charts',{attrs:{"option":_vm.option}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }